import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { ChangeEvent } from '@progress/kendo-angular-dialog/window/window-events';
import {take} from 'rxjs/operators';

@Component({
    selector: 'app-partialdialog',
    templateUrl: './partialdialog.component.html',
    styleUrls: ['./partialdialog.component.scss']
})
export class PartialdialogComponent implements OnInit {

    title: string;
    message: string;
    buttons: any;
    public wholeUnit = 0;
    public partialUnit = 0;
    public decimalValue = 0;
    buttonDefinitions: string[];
    public inventoryItem: any;
    public partialDecimal: any;
    public packSize: any | number;
    @Input()
    public opened = false;
    @Output()
    public closed = new EventEmitter<string>();

    constructor() {
        this.opened = false;
    }

    ngOnInit(): void {
    }

    BoxKeyPress($event: ChangeEvent) {
        this.calculatePartial();
    }

    calculatePartial() {
        this.partialDecimal = ((+this.partialUnit / this.packSize) + (+this.wholeUnit)).toString();
        this.decimalValue = +this.partialDecimal;
        this.inventoryItem.qty = +this.partialDecimal;
    }

    onChanged($event: Event) {
        this.calculatePartial();
    }

    public open(type: string,
                title: string,
                message: string = '',
                cancel: string = 'Cancel',
                confirm: string = 'Save',
                minWidth: number = 250,
                width: number = 450,
                minHeight: number = 250,
                height: number = 0,
                inventoryItem: any): Promise<any> {
        this.title = title;
        this.message = '';
        this.inventoryItem = inventoryItem;
        this.wholeUnit = this.inventoryItem.qty;
        this.packSize = this.inventoryItem.packSize;
        this.buttonDefinitions = ['Cancel', 'Save'];
        this.opened = true;
        if ( this.inventoryItem.qty > 0) {
            this.partialUnit = this.inventoryItem.packSize;
            this.wholeUnit = this.wholeUnit - 1;
            this.decimalValue = this.inventoryItem.qty;
        }
        return this.closed.asObservable()
            .pipe(take(1))
            .toPromise();
    }

    public close(event: any) {
        if (event.target.innerHTML === 'Save') {
            this.inventoryItem.qty = this.decimalValue;
        }
        this.opened = false;
        this.closed.emit(event.target.innerHTML);
    }
}
